// extracted by mini-css-extract-plugin
export default {"advertDetailHeaderInfo":"c-k_hg"};